import { Theme } from '@mui/material';
import { Column } from '@tanstack/react-table';

export const getPinnedSx = <T>(
  column: Column<T>,
  isHeader = false,
  isLastLeft = false,
  isFirstRight = false
) => {
  const isPinned = column.getIsPinned();
  if (!isPinned) {
    return {};
  }

  return {
    position: 'sticky' as const,
    left: isPinned === 'left' ? column.getStart('left') : undefined,
    right: isPinned === 'right' ? column.getAfter('right') : undefined,
    zIndex: 2,
    bgcolor: isHeader ? 'grey.50' : 'background.paper',
    // ::after is used instead of borderRight/borderLeft + boxShadow because
    // border-collapse:collapse causes td borders to disappear on scroll, and
    // box-shadow on td is clipped by the table element.
    // CSS custom properties (--shadow-left/right) are set imperatively on the
    // container so the shadow updates without any React re-renders.
    ...(isLastLeft
      ? {
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            width: '1px',
            backgroundColor: (theme: Theme) => theme.palette.divider,
            boxShadow: 'var(--shadow-left, none)',
          },
        }
      : {}),
    ...(isFirstRight
      ? {
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            width: '1px',
            backgroundColor: (theme: Theme) => theme.palette.divider,
            boxShadow: 'var(--shadow-right, none)',
          },
        }
      : {}),
  };
};
